// ** Icons Import
import { Home, Circle } from "react-feather";

export default [
  {
    id: "api",
    title: "API",
    icon: <Home size={20} />,
    badge: "light-warning",
    badgeText: "2",
    children: [
      {
        id: "apiKullanicilar",
        title: "API Kullanıcılar",
        icon: <Circle size={12} />,
        // navLink: '/dashboard/analytics'
      },
      {
        id: "apiSatislar",
        title: "API Satışlar",
        icon: <Circle size={12} />,
        // navLink: '/dashboard/analytics'
      },
    ],
  },
];
